
























































































































	import { Component } from "../../../Infrastructure/CorBase/CoreBase";
	import NotificationViewDetailBase from "./NotificationViewDetailBase";

	@Component
	export default class NotificationSendDetail extends NotificationViewDetailBase {
		labelWidth = "3";

		///hlaska o prekroceni inputu po Ctrl+V
		private infoShortInput(maxLength: string): void {
			this.infoShortInputBase(maxLength);
		}



		//protest
		idPerson = 1613;
		idTemplate = 5;

		title() {
			return "TEST sendTO person: " + this.idPerson + " ,template: " + this.idTemplate;
		}

		sendTemplateTest() {			
			this.sendTemplateTestBase(this.idPerson, this.idTemplate);
		}

		showSendAgain() {
			return this.showSendAgainBase();
		}

		sendAgain() {
			this.sendAgainBase();
		}

		mounted() {
			super.mounted();
		};

		created() {
			//TODO prava
			super.initializeRights('COR_NotificationSend_Create', 'COR_NotificationSend_Delete', 'COR_NotificationSend_Read', 'COR_NotificationSend_Update');
			super.setMainDescription('notificationSend.new', 'notificationSend.detail');
			this.createBase();
		}

		goBackStudent() {
			this.$router.push({ name: 'StudentDetail', params: { id: this.returnStudentId }, query: { id: this.returnStudentId, type: 'detail' } });
        }

		goToStudent(item: any) {
            this.$router.push({ name: 'StudentDetail', params: { id: item.id }, query: { id: item.id, type: 'detail' } });
		}


	}
